import type { StockItem } from '../../domain/fulfillment';

/**
 * True when every word of the query appears in the item's name, SKU,
 * barcodes or description, in any order and case. "garo male" finds
 * "Garo Male Power Connector".
 */
export function matchesStockSearch(item: StockItem, query: string): boolean {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = [item.displayName, item.sku, ...item.barcodes, item.description ?? '']
    .join(' ')
    .toLowerCase();
  return words.every((word) => haystack.includes(word));
}
